import { IdentifyProgressBar } from '../../../../../components';
import { CaptureFaceLogic } from '../_containers';

export default function CaptureFacePage() {
  return (
    <div className='flex h-dvh w-full flex-col items-center'>
      <IdentifyProgressBar currentStep={3} />
      <CaptureFaceLogic />
    </div>
  );
}
